<template>

  <q-card flat bordered>

    <!--Mobile-->
    <div class="lt-sm">

      <div class="row">

        <!--Left 8-->
        <div class="col-8 q-pa-sm" style="border-right: 2px solid whitesmoke">

          <!--Top Row-->
          <div class="row">

            <!--Term / Type-->
            <div class="col-6 q-pa-sm">

              <!--Term-->
              <div class="text-100 text-bold">
                <plan-term :term="plan.product.term"></plan-term>
              </div>

              <!--Locked-->
              <plan-type :term="plan.product.term"></plan-type>

              <!--Green-->
              <div class="text-075">{{ plan.product.percent_green }}% Green Energy</div>

            </div>

            <!--Total-->
            <div class="col-6 q-pa-sm">

              <!--Total Price / Description-->
              <div class="text-100 text-bold">
                <plan-total-price :plan="plan"></plan-total-price>
              </div>
              <div class="text-075">
                <plan-total-description :plan="plan"></plan-total-description>
              </div>

            </div>

          </div>

          <!--Bottom Row-->
          <div class="row" @click="show_details = !show_details">

            <!--Brand / Image-->
            <div class="col-6 q-pa-sm text-center">

              <plan-brand-image height="40px" width="80px" :plan="plan"></plan-brand-image>
              <div class="text-075">PUCT # {{ plan.product.brand.puct_number }}</div>
            </div>

            <!--Name / View Details-->
            <div class="col-6 q-pt-md">
              <div class="text-100 text-bold">{{ plan_name(plan) }}</div>
              <q-btn flat color="accent" size="sm" :label="show_details ? 'Hide Details' : 'Show Details'"
                     padding="none" no-caps
                     @click.stop="show_details = !show_details"></q-btn>
            </div>

          </div>

        </div>

        <!--Right 4-->
        <div class="col-4 q-pa-md text-center">

          <!--Clickable call to action div-->
          <div @click="select_plan(plan)">

            <!--Deposit-->
            <plan-deposit :deposit_amount="deposit_amount"></plan-deposit>

            <!--Average-->
            <div class="text-200 text-primary text-bold">
              <plan-average-price :plan="plan"></plan-average-price>
            </div>
            <div class="text-100 text-accent">per kWh</div>

            <!--Call to Action-->
            <q-btn v-if="show_call_to_action_button" flat class="bg-secondary text-075 text-bold rounded-borders-10"
                   color="white" :label="select_plan_label" no-caps
                   padding="5px 12px" size="sm" @click="select_plan(plan)"></q-btn>

          </div>

          <!--Phone-->
          <div class="q-mt-md" v-if="show_phone_number">
            <div v-if="show_call_to_action_button" class="text-0875">or call</div>
            <q-btn class="text-075 text-bold" padding="none" flat text-color="secondary"
                   icon="phone" :label="plan_phone_number(plan)" :href="`tel:${plan_phone_number(plan)}`">
            </q-btn>
          </div>

        </div>

      </div>

    </div>

    <!--Desktop-->
    <q-card-section class="gt-xs row items-stretch q-px-none">

      <!--Left 9-->
      <div class="col-9 flex column justify-center q-pr-sm" style="border-right: 1px solid whitesmoke">
        <div class="row">

          <!--Image / View Details-->
          <div class="col-3 text-center q-pa-md">
            <plan-brand-image width="100px" :plan="plan"></plan-brand-image>
            <div class="text-075 text-bold q-mb-sm">PUCT # {{ plan.product.brand.puct_number }}</div>
            <q-btn flat class="bg-grey-4 text-075" no-caps
                   :label="show_details ? 'Hide Plan Details' : 'View Plan Details'"
                   @click="show_details = !show_details">
            </q-btn>
          </div>

          <!--Middle-->
          <div class="col-9">

            <!--Top Row-->
            <div class="row q-col-gutter-md q-mb-lg">

              <!--Section 1 of 3 term-->
              <div class="col-4">

                <!--Term-->
                <div class="text-125 text-bold">
                  <plan-term :term="plan.product.term"></plan-term>
                </div>

                <!--Type-->
                <plan-type :term="plan.product.term"></plan-type>

                <!--Green-->
                <div class="text-0875">{{ plan.product.percent_green }}% Green Energy</div>

              </div>

              <!--Section 2 of 3 avg-->
              <div class="col-4">

                <!--Average price / description-->
                <div class="text-125 text-bold">
                  <plan-average-price :plan="plan"></plan-average-price>
                </div>
                <div class="text-0875">
                  <plan-average-description :plan="plan"></plan-average-description>
                </div>


              </div>

              <!--Section 3 of 3 total-->
              <div class="col-4">

                <!--Total Price / Description-->
                <div>
                  <div class="text-125 text-bold">
                    <plan-total-price :plan="plan"></plan-total-price>
                  </div>
                  <div class="text-0875">
                    <plan-total-description :plan="plan"></plan-total-description>
                  </div>
                </div>

              </div>
            </div>

            <!--Bottom Row Name, Desc, Historical details-->
            <div class="row q-col-gutter-md">

              <!--Name-->
              <div class="col">
                <div class="text-100 text-bold">{{ plan_name(plan) }}</div>
                <div class="text-0875">{{ plan.product.headline }}</div>
              </div>

              <!--Historical Details-->
              <plan-historical-details :plan="plan"></plan-historical-details>

            </div>

          </div>

        </div>
      </div>

      <!--Right 3-->
      <div class="col-3 text-center justify-start q-pa-md">

        <!--Deposit-->
        <plan-deposit :deposit_amount="deposit_amount"></plan-deposit>

        <!--Historical-->
        <div class="text-200 text-primary text-bold">
          <plan-average-price :plan="plan"></plan-average-price>
        </div>
        <div class="text-100 text-accent q-mb-sm">per kWh</div>

        <!--Call to Action-->
        <q-btn v-if="show_call_to_action_button" style="width: 90%" flat color="white" :label="select_plan_label"
               class="bg-secondary text-bold text-075 rounded-borders-10" padding="10px 20px" @click="select_plan(plan)"
               no-caps>
        </q-btn>


        <!--Phone-->
        <div class="q-mt-md" v-if="show_phone_number">
          <div v-if="show_call_to_action_button" class="text-0875">or call</div>
          <q-btn class="text-0875 text-bold" padding="none" flat text-color="secondary"
                 icon="phone" :label="plan_phone_number(plan)" :href="`tel:${plan_phone_number(plan)}`">
          </q-btn>
        </div>

      </div>

    </q-card-section>

    <transition appear enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div v-if="show_details">
        <plan-details :plan="plan"></plan-details>
        <pricing-details :plan="plan"></pricing-details>
      </div>
    </transition>

  </q-card>

</template>

<script>
import UsageFilters                               from "src/composables/UsageFilters";
import PlanChart                                  from "components/plans/cards/PlanChart";
import { computed, onMounted, ref, toRef, watch } from "vue";
import PlanDetails                                from "components/plans/cards/PlanDetails";
import PricingDetails                             from "components/plans/cards/PricingDetails";
import Utilities                                  from "src/composables/Utilities";
import SelectedPlan                               from "src/composables/SelectedPlan";
import { useRouter }                              from "vue-router";
import Analytics                                  from "src/composables/Analytics";
import Plans                                      from "src/composables/Plans";
import PlanBrandImage                             from "components/plans/misc/PlanBrandImage";
import PlanTerm                                   from "components/plans/misc/PlanTerm";
import PlanType                                   from "components/plans/misc/PlanType";
import PlanDeposit                                from "components/plans/misc/PlanDeposit";
import PlanAveragePrice                           from "components/plans/misc/PlanAveragePrice";
import PlanAverageDescription                     from "components/plans/misc/PlanAverageDescription";
import PlanTotalPrice                             from "components/plans/misc/PlanTotalPrice";
import PlanTotalDescription                       from "components/plans/misc/PlanTotalDescription";
import PlanHistoricalDetails                      from "components/plans/misc/PlanHistoricalDetails";
import { cp_bg_c_cart_2025_02_03 }                from "src/composables/Cart";

export default {
  name: "HorizontalPlanCard",
  components: {
    PlanHistoricalDetails,
    PlanTotalDescription,
    PlanTotalPrice,
    PlanAverageDescription,
    PlanAveragePrice,
    PlanDeposit,
    PlanType,
    PlanTerm,
    PlanBrandImage,
    PricingDetails,
    PlanDetails,
    PlanChart
  },
  props: {
    plan: {
      type: Object,
      required: true
    },
    deposit_amount: {
      type: Number
    },
    select_plan_label: {
      type: String,
      default: 'Check Availability'
    },
    hide_call_to_action: {
      type: Boolean,
      default: false
    },
    hide_phone_number: {
      type: Boolean,
      default: false
    },
    sort_index: {
      type: Number
    }
  },
  setup(props, { emit }) {
    const plan = ref(null);
    const plan_ro = toRef(props, 'plan');
    const { plan_phone_number, plan_name, plan_to_ecommerce } = Utilities();
    const { log_event } = Analytics();
    const { show_historical_usage, historical_usage_values, usage_selected } = UsageFilters()
    const { calculate_plan_for_usage, plan_map, historical_usage_plan_map } = Plans();

    const format_plan = async () => {
      plan.value = plan_ro.value;
      if (plan.value) {
        const missing_usages = [];
        if (show_historical_usage.value) {
          for (const hi of historical_usage_values.value) {
            if (!plan.value[`display_pricing_${ hi }`]) {
              missing_usages.push(hi)
            }
          }
        }
        else if (!plan.value[`display_pricing_${ usage_selected.value }`]) {
          missing_usages.push(usage_selected.value)
        }
        for (const usage of missing_usages) {
          plan.value[`display_pricing_${ usage }`] = await calculate_plan_for_usage({
            plan_id: plan.value._id,
            usage: usage
          })
        }
        if (show_historical_usage.value) {
          plan.value = historical_usage_plan_map(plan.value)
        }
        else {
          plan.value = plan_map(plan.value)
        }
      }
    }

    watch([plan_ro], () => {
      format_plan()
    })

    onMounted(() => {
      format_plan()
    })

    // featured = false only works because we don't use this component for featured plans
    // if you use this for featured plans, make sure and refactor
    const show_details = ref(false);
    watch(show_details, () => {
      if (show_details.value) {
        log_event({
          name: 'shop_plan_view_details',
          shop: {
            plan: { ...props.plan, app_properties: { featured: false, sort_index: props.sort_index } }
          }
        });
        log_event({
          name: 'view_item',
          keep_name: true,
          ecommerce: {
            items: [
              plan_to_ecommerce({ plan: props.plan, sort_index: props.sort_index })
            ]
          }
        })
      }
    })


    const select_plan = function (plan) {
      emit('selected', { ...plan, featured: false, sort_index: props.sort_index });
    }

    const show_call_to_action_button = computed(() => {
      return !props.plan.product.brand.configuration.hide_sign_up_button && !props.hide_call_to_action
    })

    const show_phone_number = computed(() => {
      return !props.hide_phone_number && !props.plan.product.brand.configuration?.hide_phone_number && !props.hide_call_to_action;
    })

    return {
      show_details,
      plan_phone_number,
      plan_name,
      select_plan,
      show_call_to_action_button,
      show_phone_number
    }
  }
}
</script>

<style lang="scss" scoped>
$rfs-base-value: .70rem;

@import "rfs/scss";

.provider-img {
  @include font-size(5rem);
}


</style>
